
window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Expired sessions don't error on write requests here — the CSRF middleware
 * 302s, axios follows the redirect, and the "response" is the homepage HTML
 * with a 200. Every Vue save (scribbles, planner, notes…) would silently
 * lose its data. Detect that shape and fail loudly instead (2026-07-24 —
 * production stopped using the dimension overrides because of this).
 */
window.axios.interceptors.response.use(function (response) {
    const method = (response.config && response.config.method || '').toLowerCase();
    const isWrite = ['post', 'put', 'patch', 'delete'].indexOf(method) !== -1;
    const looksLikeHtmlPage = typeof response.data === 'string'
        && /<!doctype html|<html/i.test(response.data.slice(0, 200));
    if (isWrite && looksLikeHtmlPage) {
        alert('Your session has expired — nothing was saved.\n\nReload the page, log in, then try again.');
        return Promise.reject(new Error('Session expired — write request redirected to a page'));
    }
    return response;
});

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'

window.Pusher = require('pusher-js');

let isLocal = window.location.hostname !== 'qapp.artgraphics.co.uk';

let pusherKey = isLocal ? process.env.MIX_PUSHER_APP_KEY_LOCAL : process.env.MIX_PUSHER_APP_KEY;

if (pusherKey) {
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: pusherKey,
        cluster: isLocal ? process.env.MIX_PUSHER_APP_CLUSTER_LOCAL : process.env.MIX_PUSHER_APP_CLUSTER,
        encrypted: true
    });
} else {
    // No-op Echo so components don't crash when Pusher keys aren't configured
    let noop = () => ({ listen: noop, leave: noop, channel: noop, leaveChannel: noop });
    window.Echo = { channel: noop, leave: noop, leaveChannel: noop };
    console.warn('Pusher key not configured — real-time updates disabled.');
}

